import { render, staticRenderFns } from "./contentInfo.vue?vue&type=template&id=6fcc9434&scoped=true"
import script from "./contentInfo.vue?vue&type=script&lang=js"
export * from "./contentInfo.vue?vue&type=script&lang=js"
import style0 from "./contentInfo.vue?vue&type=style&index=0&id=6fcc9434&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcc9434",
  null
  
)

export default component.exports